import { render, staticRenderFns } from "./ProductCustomizationFilters.vue?vue&type=template&id=905677d6&scoped=true&"
import script from "./ProductCustomizationFilters.vue?vue&type=script&lang=js&"
export * from "./ProductCustomizationFilters.vue?vue&type=script&lang=js&"
import style0 from "./ProductCustomizationFilters.vue?vue&type=style&index=0&id=905677d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905677d6",
  null
  
)

export default component.exports